import { useId } from "@floating-ui/react"
import clsx from "clsx"
import { forwardRef } from "react"

interface ItemProps {
  children: React.ReactNode
  active: boolean
  selected: boolean
}

export const Item = forwardRef<HTMLDivElement, ItemProps & React.HTMLProps<HTMLDivElement>>(({ children, active, selected, ...rest }, ref) => {
  const id = useId()
  return (
    <div
      ref={ref}
      role="option"
      id={id}
      tabIndex={0}
      aria-selected={active}
      className={clsx("custom-select__list-item", active && "custom-select__list-item--active", selected && "custom-select__list-item--selected")}
      {...rest}
    >
      {children}
    </div>
  )
})
